import React from 'react';
import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from 'shards-react';
import getTradingCompanyName from '../../../utils/getTradingCompanyName';
import { LANGUAGE } from '../../../constants';
import type { NewsType } from '../../../types/news';
import type { OptionsType } from '../../../types/options';

interface NewsItemProps {
  news: NewsType;
  tradingCompany: OptionsType<string>[];
}

const NewsItem = ({ news, tradingCompany }: NewsItemProps): React.ReactElement => {
  const { title, message, tradingCompanyCode } = news;
  const tradingCompanyNameJa: string = getTradingCompanyName(tradingCompanyCode, { tradingCompanies: tradingCompany, language: LANGUAGE.JA });
  const tradingCompanyNameEn: string = getTradingCompanyName(tradingCompanyCode, { tradingCompanies: tradingCompany, language: LANGUAGE.EN });

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <ListGroup>
      <ListGroupItem>
        <ListGroupItemHeading style={{ fontSize: '1rem' }}>
          {tradingCompanyNameJa}／{tradingCompanyNameEn}
        </ListGroupItemHeading>
        <ListGroupItemHeading style={{ fontSize: '1rem' }}>{title}</ListGroupItemHeading>
        <ListGroupItemText>{message}</ListGroupItemText>
      </ListGroupItem>
    </ListGroup>
  );
};

export default NewsItem;
